var _Object$freeze;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createUseStyles } from 'react-jss';
import { PackageType } from '@sm/utils';

// This file helps us map a packageId to its conventional color & background color
// as shown on the billing pages.
// https://code.corp.surveymonkey.com/devmonkeys/BillWeb/blob/develop/billweb/static/scss/_packages.scss
// https://github.com/mntv-webplatform/smweb/blob/master/apps/contentweb/src/app/pages/Pricing/lib/package-colors.scss

var toColorScheme = Object.freeze((_Object$freeze = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Object$freeze, PackageType.ADVANTAGE_ANNUAL, 'advantage'), PackageType.ADVANTAGE_MONTHLY, 'advantage'), PackageType.ANALYZE_PACKAGE, 'analyze'), PackageType.BASIC, 'basic'), PackageType.ENTERPRISE_CASUAL_USER, 'enterprise'), PackageType.ENTERPRISE_CONTRIBUTOR_SEAT, 'enterprise'), PackageType.ENTERPRISE_PLATINUM, 'enterprise'), PackageType.ENTERPRISE, 'enterprise'), PackageType.PREMIER_ANNUAL, 'premier'), PackageType.PREMIER_MONTHLY, 'premier'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Object$freeze, PackageType.STANDARD_ANNUAL, 'standard'), PackageType.STANDARD_MONTHLY, 'standard'), PackageType.TEAM_ADVANTAGE_ANNUAL, 'team_advantage'), PackageType.TEAM_ADVANTAGE_CONTRIBUTOR_SEAT, 'team_advantage'), PackageType.TEAM_PREMIER_ANNUAL, 'team_premier'), PackageType.TEAM_PREMIER_CONTRIBUTOR_SEAT, 'team_premier')));
var wrenchBadgeSizeSm = 22;

// These hardcoded colors can be removed when billing pages adopt Wrench theming. At present
// they're using the SM brand colors, which don't map 1:1 to the Wrench palette
var SM_RASPBERRY = '#AC145A';
var SM_MIDNIGHT = '#05467E';
var SM_ARCTIC = '#2DCCD3';
var SM_CONCORD = '#671E75';
var useStyles = createUseStyles(function (theme) {
  var type = theme.type,
    spacing = theme.spacing,
    radius = theme.radius,
    palette = theme.palette;
  var data = palette.data,
    text = palette.text,
    link = palette.link;
  var badgeStyles = {
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: type.fontSize.bodySm,
    fontWeight: type.fontWeight.medium,
    padding: "0 ".concat(spacing[2], "px"),
    maxWidth: '100%',
    height: "".concat(wrenchBadgeSizeSm, "px"),
    lineHeight: "".concat(wrenchBadgeSizeSm, "px"),
    borderRadius: radius.small
  };
  var packageColors = {
    advantage: [text.light, data.two],
    // sabaeus
    analyze: [text.light, SM_RASPBERRY],
    // raspberry
    basic: [text.dark, text.lightMuted],
    // flint
    enterprise: [text.light, SM_MIDNIGHT],
    // midnight
    premier: [text.light, SM_MIDNIGHT],
    // midnight
    standard: [text.dark, SM_ARCTIC],
    // arctic
    team_advantage: [link.contrast, link.main],
    // link
    team_premier: [text.light, SM_CONCORD],
    // concord

    // fallback
    default: [text.dark, text.lightMuted] // flint
  };
  var getPackageColors = function getPackageColors(packageId) {
    var key = toColorScheme[packageId] || 'default';
    var _packageColors$key = _slicedToArray(packageColors[key], 2),
      color = _packageColors$key[0],
      backgroundColor = _packageColors$key[1];
    return {
      color: color,
      backgroundColor: backgroundColor
    };
  };
  return {
    badge: function badge(_ref) {
      var packageId = _ref.packageId;
      return _objectSpread(_objectSpread({}, badgeStyles), getPackageColors(packageId));
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map